module.exports = __webpack_public_path__ + "static/media/gt.55a2d0d8.svg";